/**
 * @file 
 * Reactのエントリポイントです。
 * このアプリケーションが実行されると最初に呼び出されます
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
// import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { Helmet } from "react-helmet";
import { Grow, makeStyles } from "@material-ui/core";
import WrapApp from "WrapApp";
//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const domain = document.domain;

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <WrapApp />
  </BrowserRouter>,
  rootElement
);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();
